import { useQueryClient } from "@tanstack/react-query";
import type { paths } from "@entities/journal";
import { journalsQueries } from "@entities/journal";
import { $journalApi } from "@entities/journal/fetch/fetch-client.ts";

type UpdateJournalCommonPayload =
  paths["/api/v1/journals/title/{titleId}/common"]["put"]["requestBody"]["content"]["application/json"];

interface IUseUpdateJournalCommon {
  titleId: string;
}

export function useUpdateJournalCommon({ titleId }: IUseUpdateJournalCommon) {
  const queryClient = useQueryClient();
  const mutation = $journalApi.useMutation(
    "put",
    "/api/v1/journals/title/{titleId}/common",
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getTitleJournal({ titleId }).queryKey,
        });
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getJournalSignersList(titleId).queryKey,
        });
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getResponsibleCommentList(titleId).queryKey,
        });
      },
    },
  );

  return {
    ...mutation,
    mutate: (
      {
        titleId,
        mainJournalNumber,
        projectCharacteristics,
        constructionStartDate,
        constructionEndDate,
        mainJournalStartDate,
        mainJournalEndDate,
      }: {
        titleId: string;
        mainJournalNumber: string;
        projectCharacteristics: string;
        constructionStartDate: string;
        constructionEndDate: string;
        mainJournalStartDate: string;
        mainJournalEndDate: string;
      },
      mutateOptions?: {
        onSuccess?: () => void;
        onError?: () => void;
        onSettled?: () => void;
      },
    ) => {
      const payload: UpdateJournalCommonPayload = {
        mainJournalNumber,
        projectCharacteristics,
        constructionStartDate,
        constructionEndDate,
        mainJournalStartDate,
        mainJournalEndDate,
      };

      mutation.mutate(
        {
          params: {
            path: { titleId },
          },
          body: payload,
        },
        mutateOptions,
      );
    },
  };
}
